// extracted by mini-css-extract-plugin
export var currencyInput = "_ja-1";
export var currencySymbol = "_ja-0";